import React, { useState, useEffect } from "react";
import { SearchNangCao } from "./SearchNangCao";
import { useSelector, useDispatch } from "react-redux";
import {
  getListDuNoNhanVay,
  updateDataSearch,
} from "../../../../actions/DuNoNhanVay";
import { formatDayMonth } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import userApi from "service/userApi";

export const SearchBarDesktop = ({}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const DanhSachCombo = {
    nhanVienOption: [
      {
        label: "Test828@gmail.com",
        value: "Test828@gmail.com",
      },
      {
        label: "Test@gmail.com",
        value: "Test@gmail.com",
        selected: true,
      },
    ],
  };

  const [listUser, setListUser] = useState(DanhSachCombo.nhanVienOption);

  useEffect(() => {
    //Code lấy list user
    userApi.combo().then((response) => {
      const dataComboUser = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setListUser(dataComboUser);
    });
  }, []);

  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchDuNoNhanVay);

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

  const onSearch = () => {
    dispatch(getListDuNoNhanVay(dataSearch));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: event,
        })
      );
      dispatch(getListDuNoNhanVay(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  // convert sự kiện tìm kiếm từ ngày đến ngày
  var dateFrom = currentDate();
  if (dataSearch.dateFrom === "01/01/2001") dateFrom = "";
  else dateFrom = dataSearch.dateFrom;
  var dateTo = currentDate();
  if (dataSearch.dateTo === "01/01/4000") dateTo = "";
  else dateTo = dataSearch.dateTo;
  dateTo = convertDate(dateTo);
  dateFrom = convertDate(dateFrom);

  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        <div className="input-sm-new input-new-25">
          <input
            type="text"
            className="form-control input-sm"
            value={dataSearch.tenChuNo}
            onChange={updateTextValue("tenChuNo")}
            onKeyDown={handleKeyDown}
            placeholder="Tên, SĐT chủ nợ"
          />
        </div>

        <div className="input-sm-new input-new-18">
          <DateTimePicker
            value={dateFrom}
            onChange={onChangeDate("dateFrom")}
            placeholder="Từ ngày"
            name="dateFrom"
          ></DateTimePicker>
        </div>

        <div className="input-sm-new input-new-18">
          <DateTimePicker
            value={dateTo}
            onChange={onChangeDate("dateTo")}
            placeholder="Đến ngày"
            name="dateFrom"
          ></DateTimePicker>
        </div>

        <div className="input-sm-new input-new-18">
          <select
            name="nhanvien"
            className="selectBox form-control input-sm"
            value={dataSearch.nhanvien}
            onChange={updateDropdown("nhanvien")}
          >
            {listUser &&
              listUser.map((item, idx) => (
                <option key={"objComboStore1" + idx} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>

        {/* <div className="input-sm-new input-new-18 search-main-new">
          <button type="submit" className="btn btn-info-new" onClick={onSearch}>
            <i className="la la-search"></i>
          </button>
          <a
            href={() => false}
            className="card-link blue darken-2 text-search-new"
            onClick={handleShow}
          >
            Nâng cao
          </a>
        </div> */}
        <div className="input-sm-new input-new-18 search-main-new">
          <button type="submit" className="btn btn-info-new" onClick={onSearch}>
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
          <a
            href={() => false}
            className="card-link blue darken-2 text-search-new filter-search"
            onClick={handleShow}
          >
            <i>
              <img
                className="icon-bred-home"
                src="/app-assets/images/icon-fitter-v2.png"
                alt=""
                style={{ scale: "0.9", verticalAlign: "sub" }}
              />
            </i>
          </a>
        </div>
        {show && <SearchNangCao show={show} onHide={handleClose} />}
      </div>
    </>
  );
};
